import { type IMatchConfigEntry, isProceduralMapConfig, type StubTiledMapOptions } from '@nova/types';

import { getProceduralMapTfConfig, proceduralMapTfToStubOptions, type ProceduralStubResolveOptions } from './procedural-map-tf.config';

/**
 * Stub dimensions for a lobby match config when it is procedural; `undefined` for CDN maps.
 * Throws if the map opts into procedural generation but no catalog entry matches its mapAssetName.
 * Match-type catalogs append inside the lookup; AGE/RE callers stay match-type-agnostic.
 *
 * Pass `tilePx` from the shared action-game `pxPerUnit` when available so stub pitch matches the engine.
 */
export function resolveProceduralStubOptions(
  matchConfig: IMatchConfigEntry,
  options?: ProceduralStubResolveOptions
): StubTiledMapOptions | undefined {
  if (!isProceduralMapConfig(matchConfig)) {
    return undefined;
  }

  const tfMap = getProceduralMapTfConfig(matchConfig.mapAssetName);
  if (tfMap) {
    return proceduralMapTfToStubOptions(tfMap, options);
  }

  throw new Error(`[resolveProceduralStubOptions] missing procedural stub options for mapAssetName <${matchConfig.mapAssetName}>`);
}
